import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@app/shared/components/components.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { ScanEventsComponent } from './scan-events.component';
import { SortScansReportsComponent } from './components/sort-scans-reports/sort-scans-reports.component';
import { PickupScansReportsComponent } from './components/pickup-scans-reports/pickup-scans-reports.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);

/**
 * Route configuration for Scan Events module.
 * NOTE: ScopeGuard removed intentionally - scope checks are handled at component level
 * and backend endpoints still enforce scopes via @ScopesDecorator() + @UseGuards().
 * This allows users with EITHER sorts OR pickups scope to access the page.
 */
const routes: Routes = [
  {
    path: '',
    component: ScanEventsComponent,
    canActivate: [AngularFireAuthGuard], // Only check auth, NOT scopes
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
  },
];

@NgModule({
  imports: [ComponentsModule, CommonModule, RouterModule.forChild(routes), SharedModule],
  exports: [RouterModule],
  declarations: [ScanEventsComponent, SortScansReportsComponent, PickupScansReportsComponent],
})
export class ScanEventsModule {}
